/**
 * branch_* グループ名から表示用ラベルを解決するユーティリティ。
 * 既知グループは日本語名へ変換し、未知グループは suffix をそのまま使用する。
 */

/** Cognitoのグループ名から受け取る値。文字列・配列・未設定のいずれもあり得る */
export type BranchGroupsInput = readonly unknown[] | string | null | undefined;

const BRANCH_GROUP_LABEL_MAP: Record<string, string> = {
  branch_aomori: '青森',
  branch_tokyo: '東京',
  branch_towada: '十和田',
  branch_misawa: '三沢',
  branch_mutsu: 'むつ',
  branch_sannohe: '三戸',
  branch_gonohe: '五戸',
  branch_morioka: '盛岡',
  branch_kuji: '久慈',
  branch_ninohe: '二戸',
};

const normalizeGroups = (groups: BranchGroupsInput): unknown[] => {
  if (Array.isArray(groups)) return [...groups];
  if (typeof groups === 'string') return [groups];
  return [];
};

export const resolveBranchGroupLabel = (groupName: unknown): string => {
  const group = String(groupName || '').trim();
  if (!group) return '';

  const lower = group.toLowerCase();
  if (!lower.startsWith('branch_')) return '';

  if (Object.prototype.hasOwnProperty.call(BRANCH_GROUP_LABEL_MAP, lower)) {
    return BRANCH_GROUP_LABEL_MAP[lower];
  }

  return group.slice('branch_'.length).trim();
};

export const getBranchGroupLabel = (groups: BranchGroupsInput): string => {
  const normalized = Array.from(new Set(
    normalizeGroups(groups)
      .map((group) => String(group || '').trim())
      .filter(Boolean)
  ));

  const branchGroup = normalized.find((group) => group.toLowerCase().startsWith('branch_'));
  return resolveBranchGroupLabel(branchGroup);
};

export const getBranchBracketLabel = (groups: BranchGroupsInput): string => {
  const label = getBranchGroupLabel(groups);
  return label ? `【${label}】` : '';
};
